import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["isMenuShown", "labelKey", "maxResults", "paginate", "text"];
import { useEffect, useState } from 'react';
import { getStringLabelKey, getTruncatedOptions } from '../../utils';
function usePagination(_ref) {
  var isMenuShown = _ref.isMenuShown,
    labelKey = _ref.labelKey,
    maxResults = _ref.maxResults,
    paginate = _ref.paginate,
    text = _ref.text,
    props = _objectWithoutProperties(_ref, _excluded);
  var results = _toConsumableArray(props.results);
  var _useState = useState(maxResults),
    _useState2 = _slicedToArray(_useState, 2),
    shownResults = _useState2[0],
    setShownResults = _useState2[1];

  // Reset shown results when the menu closes or the input text changes
  useEffect(function () {
    setShownResults(maxResults);
  }, [isMenuShown, maxResults, text]);
  function onPaginate(e) {
    setShownResults(function (prevShownResults) {
      var _props$onPaginate;
      var newShownResults = prevShownResults + maxResults;
      (_props$onPaginate = props.onPaginate) === null || _props$onPaginate === void 0 || _props$onPaginate.call(props, e, newShownResults);
      return newShownResults;
    });
  }

  // This must come before results are truncated.
  var shouldPaginate = paginate && results.length > shownResults;
  results = getTruncatedOptions(results, shownResults);

  // Add the pagination item if necessary.
  if (shouldPaginate) {
    results.push(_defineProperty(_defineProperty({}, getStringLabelKey(labelKey), ''), "paginationOption", true));
  }
  return {
    onPaginate: onPaginate,
    results: results
  };
}
export default usePagination;